/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Mattia Penna",
  title: "PHP Developer - Mattia Penna",
  subTitle: emoji(
    "Hello there! I'm an experienced full stack developer specialized in PHP and frameworks. I have extensive experience in building reliable web and mobile applications."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1AYiIcOrlU92gAY4JcYWfNAH0ax6OslOu/view?usp=sharing", // Set to empty to hide the button
  logo: require("./assets/images/mattiaPennaLogo.png"),
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/tiapnn",
  linkedin: "https://www.linkedin.com/in/tiapnn/",
  gmail: "info@mattiapenna.dev",
  blog: "https://ambidestro.it",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "My Tech Stack",
  subTitle: "WHAT CAN I DO FOR YOU?",
  skills: [
    emoji(
      "- I develop highly interactive user interfaces for web and mobile applications."
    ),
    emoji("- I am an expert in SEO and SEO copywriting. I can help you reach more customers."),
    emoji(
      "- I have a lot of experience integrating third-party services such as Firebase and Stripe Payments into e-commerce websites and web services."
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Symfony",
      fontAwesomeClassname: "fab fa-symfony"
    },
    {
      skillName: "Laravel",
      fontAwesomeClassname: "fab fa-laravel"
    },
    {
      skillName: "PHP",
      fontAwesomeClassname: "fab fa-php"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "VueJs",
      fontAwesomeClassname: "fab fa-vuejs"
    },
    {
      skillName: "NodeJs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "SQL database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "Firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Azure",
      fontAwesomeClassname: "fab fa-microsoft"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Universitat Politècnica de València (UPV)",
      logo: require("./assets/images/upvLogo.jpeg"),
      subHeader: "Bootcamp CP-UPV, Computer Science",
      duration: "Jan 2025 - Dec 2025",
      desc: "Competitive Programming and C++",
      descBullets: [
        "C++ programming with data types",
        "Core data structures, maps, sets and priority queues",
        "Fundamental algorithms and greedy strategies",
        "Graph algorithms including BFS, DFS and DSU",
        "Advanced topics covering segment trees"
      ]
    },
    {
      schoolName: "New Horizons of NE Florida",
      logo: require("./assets/images/newHorizonLogo.jpeg"),
      subHeader: "Microsoft Certificate of Archivement",
      duration: "July 2021 - August 2021",
      desc: "Developing ASP.NET Core MVC Web Applications",
      descBullets: [
        "Designing ASP.NET Core MVC Web Applications",
        "Configuring Middleware and Services in ASP.NET Core",
        "Using Entity Framework Core in ASP.NET Core",
        "Hosting and Deployment"
      ]
    },
    {
      schoolName: "freeCodeCamp",
      logo: require("./assets/images/freeCodeCampLogo.jpg"),
      subHeader: "Full Stack Certification",
      duration: "Jan 2020 - Jun 2020",
      desc: "Developer Certification, representing approximately 1800 hours of coursework",
      descBullets: [
        "Responsive Web Design Certification",
        "JavaScript Algorithms and Data Structures Certification",
        "Front End Libraries Certification",
        "Data Visualization Certification",
        "APIs and Microservices Certification",
        "Quality Assurance Certification"
      ]
    },
    {
      schoolName: "Devscola",
      logo: require("./assets/images/devscolaLogo.png"),
      subHeader: "RUN 2020",
      duration: "Feb 2020 - Jul 2020",
      desc: "Semestral coursework",
      descBullets: [
        "AGILE methodologies, Scrum y Kanban",
        "Unix enviroments, Linux with Ubuntu",
        "SOLID principles, Test Driven Development",
        "Object Oriented Programming, MVC, Clean Code",
        "Version control GIT & Github"
      ]
    },
    {
      schoolName: "AFS Intercultural Programs",
      logo: require("./assets/images/afsLogo.jpeg"),
      subHeader: "Semester Abroad",
      duration: "Aug 2011 - Jan 2012",
      desc: "Selected participant in a semester-long AFS intercultural exchange in Brazil, focused on cultural immersion, language development, and global citizenship.",
      descBullets: [
        "Portuguese",
        "English"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Backend", //Insert stack or technology you have experience in
      progressPercentage: "99%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Frontend",
      progressPercentage: "93%"
    },
    {
      Stack: "DevOps",
      progressPercentage: "85%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Full Stack Developer",
      company: "Group One",
      companylogo: require("./assets/images/oneLogo.jpeg"),
      color: "#FDC600",
      date: "Apr 2025 – Present",
      desc: "Development and maintenance of web applications within the Group.one ecosystem. Used Laravel, PHP, Vue, Inertia & OpenStack",
      descBullets: [
        "Cloud server management and deployment",
        "OpenStack integration for cloud infrastructure provisioning",
        "Improvement of cloudserver related APIs"
      ]
    },
    {
      role: "Full Stack Developer",
      company: "PFS Tech",
      companylogo: require("./assets/images/pfsLogo.png"),
      color: "#EE593A",
      date: "Dec 2024 – Mar 2025",
      desc: "Development of a backend microservice for a Mercedes-Benz financial product. Used Laravel, PHP, Blade & Docker",
      descBullets: [
        "Rest API",
        "Signaturit & Mobbeel integrations",
        "Custom payment integration",
        "Admin dashboard"
      ]
    },
    {
      role: "Full Stack Developer",
      company: "Invisible Geeks",
      companylogo: require("./assets/images/invisibleLogo.jpeg"),
      color: "#000000",
      date: "Jun 2024 – Nov 2024",
      desc: "Development and maintenance of digital product. Used Laravel, PHP, Inertia & Vue",
      descBullets: [
        "Web apps",
        "AI integrations",
        "Admin dashboard"
      ]
    },
    {
      role: "Full Stack Developer - Team Lead",
      company: "Concierge",
      companylogo: require("./assets/images/conciergeLogo.png"),
      color: "#FBBC20",
      date: "Jul 2021 – Present",
      desc: "Lead, development & setup of a digital product. Used Symfony, Ionic, PHP & Vue",
      descBullets: [
        "Admin dashboard",
        "WebApp, Android & iOS apps",
        "Project Management"
      ]
    },
    {
      role: "Full Stack Developer - Team Lead",
      company: "Istobal",
      companylogo: require("./assets/images/istobalLogo.png"),
      color: "#D9002D",
      date: "Feb 2021 – Apr 2022",
      desc: "Development and maintenance of tech services. Used Symfony, Docker, Redis & Microsoft Azure",
      descBullets: [
        "Admin dashboard",
        "Rest API",
        "Android & iOS apps",
        "Web Terminals"
      ]
    },
    {
      role: "Full Stack Developer",
      company: "Essedi",
      companylogo: require("./assets/images/essediLogo.png"),
      color: "#00428B",
      date: "Apr 2020 – Feb 2021",
      desc: "Development and maintenance of several e-commerce websites and webpages. Used CodeIgniter, PHP, Javascript & SCSS",
      descBullets: [
        "pistasta.it",
        "sicilyprodottitipici.it",
        "donocasion.es"
      ]
    },
    {
      role: "Full Stack Developer",
      company: "PNZ Devs",
      companylogo: require("./assets/images/pnzdevsLogo.jpg"),
      color: "#F5F5F5",
      date: "January 2020 – Apr 2022",
      desc: "Development of various websites as a private contractor. Used Vue, Nuxt, Strapi, Prestashop, Wordpress & AWS",
      descBullets: [
        "vicenteperpy.com",
        "cirquedejari.com",
        "ambidestro.it",
      ]
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@tiapnn/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+34 691 96 92 03",
  email_address: "info@mattiapenna.dev"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
